"use client";
import React, { useState } from "react";
import { Rnd } from "react-rnd";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/cartSlice";
import { useNavigate } from "react-router-dom";
import html2canvas from "html2canvas";


const generatePreview = async (item) => {
  const wrapper = document.createElement("div");
  wrapper.style.position = "absolute";
  wrapper.style.left = "-9999px";
  wrapper.style.width = "380px";
  wrapper.style.height = "460px";
  wrapper.style.background = "white";

  wrapper.innerHTML = `
    <div style="position:relative;width:380px;height:460px;">
      <img src="${item.tshirt}" style="width:100%;height:100%;object-fit:contain"/>
      <img src="${item.pattern}"
        style="
          position:absolute;
          left:${item.patternX}px;
          top:${item.patternY}px;
          width:${item.patternSize}px;
          height:${item.patternSize}px;
        "
      />
    </div>
  `;

  document.body.appendChild(wrapper);
  const canvas = await html2canvas(wrapper, { scale: 2 });
  document.body.removeChild(wrapper);

  return canvas.toDataURL("image/png");
};


export default function CustomizationTShirtPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const themes = [
  { name: "Bikes", icon: "/theme-icons/bikes.webp" },
  { name: "Animal", icon: "/theme-icons/animal.webp" },
  { name: "Streetwear", icon: "/theme-icons/streetwear.webp" },
  { name: "Quotes", icon: "/theme-icons/quotes.webp" },
  { name: "One Piece", icon: "/theme-icons/onepiece.webp" },
  { name: "Naruto", icon: "/theme-icons/naruto.webp" },
  { name: "Dragon Ball", icon: "/theme-icons/dragonball.webp" },
  { name: "Summer Design", icon: "/theme-icons/summerdesign.webp" },
  { name: "Space Hustle", icon: "/theme-icons/spacehustle.webp" },
  { name: "Cars", icon: "/theme-icons/cars.webp" },
];


  const [selectedTheme, setSelectedTheme] = useState("Bikes");
  const [selectedColor, setSelectedColor] = useState("white");
  const [size, setSize] = useState("M");
  const [qty, setQty] = useState(1);
  const price = 499;

  const [placedPatterns, setPlacedPatterns] = useState([]);
  const [orders, setOrders] = useState([]);
  const [errorText, setErrorText] = useState("");
  const [activeTab, setActiveTab] = useState("editor");

  // POPUP PREVIEW STATE
  const [showPopup, setShowPopup] = useState(false);

 const patternList = Array.from({ length: 10 }, (_, i) => {
  return `/patterns/${selectedTheme
    .toLowerCase()
    .replace(/\s+/g, "")}/${i + 1}.webp`;
});


  const tshirtImages = {
  white: "/mockups/tshirt-white.png",
  black: "/mockups/tshirt-black.png",
  navy: "/mockups/tshirt-navy.png",
  brown: "/mockups/tshirt-brown.png",
  cream: "/mockups/tshirt-cream.png",
  skyblue: "/mockups/tshirt-skyblue.png",
};


  const CANVAS_W = 380;
  const CANVAS_H = 460;
  const THUMB_W = 72;
  const THUMB_H = Math.round((THUMB_W / CANVAS_W) * CANVAS_H);
const POPUP_W = 380;
const POPUP_SCALE = POPUP_W / CANVAS_W;


  const addPattern = (url) => {
   setPlacedPatterns([
  {
    id: Date.now(),
    url,
    x: 120,
    y: 120,
    size: 150,
  },
]);


    setErrorText("");
  };

  const removePattern = () => setPlacedPatterns([]);

  const addOrderLine = () => {
    if (placedPatterns.length === 0) {
      setErrorText("Please add a pattern before adding the item.");
      return;
    }

    setErrorText("");
    const p = placedPatterns[0];

    const snapshot = {
      color: selectedColor,
      sizeLabel: size,
      theme: selectedTheme,
      pattern: p.url,
      patternX: Math.round(p.x),
      patternY: Math.round(p.y),
      patternSize: Math.round(p.size),
    };

    setOrders((prev) => {
      const exists = prev.findIndex(
        (o) =>
          o.color === snapshot.color &&
          o.sizeLabel === snapshot.sizeLabel &&
          o.theme === snapshot.theme &&
          o.pattern === snapshot.pattern &&
          o.patternX === snapshot.patternX &&
          o.patternY === snapshot.patternY &&
          o.patternSize === snapshot.patternSize
      );

      if (exists !== -1) {
        const updated = [...prev];
        const item = updated[exists];
        const newQty = item.qty + qty;
        updated[exists] = {
          ...item,
          qty: newQty,
          total: newQty * item.price,
        };
        return updated;
      }

      return [
        ...prev,
        {
          id: Date.now(),
          color: snapshot.color,
          qty,
          price,
          total: qty * price,
          tshirt: tshirtImages[snapshot.color],
          pattern: snapshot.pattern,
          patternX: snapshot.patternX,
          patternY: snapshot.patternY,
          patternSize: snapshot.patternSize,
          sizeLabel: snapshot.sizeLabel,
          theme: snapshot.theme,
        },
      ];
    });
  };

  const increaseOrderQty = (id) => {
    setOrders((prev) =>
      prev.map((o) =>
        o.id === id ? { ...o, qty: o.qty + 1, total: (o.qty + 1) * o.price } : o
      )
    );
  };

  const decreaseOrderQty = (id) => {
    setOrders((prev) =>
      prev
        .map((o) =>
          o.id === id
            ? { ...o, qty: Math.max(0, o.qty - 1), total: Math.max(0, o.qty - 1) * o.price }
            : o
        )
        .filter((o) => o.qty > 0)
    );
  };

  const deleteOrderLine = (id) => {
    setOrders((prev) => prev.filter((o) => o.id !== id));
  };

  const subtotal = orders.reduce((s, o) => s + o.total, 0);

 const addAllToReduxCart = async () => {
  for (const item of orders) {
    const previewImage = await generatePreview(item);

    dispatch(
      addToCart({
        productId: crypto.randomUUID(),
        name: "Customized T-Shirt",
        theme: item.theme,
        color: item.color,
        size: item.sizeLabel,
        quantity: item.qty,
        price: item.price,
        subtotal: item.total,

        tshirt: item.tshirt,
        pattern: item.pattern,
        patternX: item.patternX,
        patternY: item.patternY,
        patternSize: item.patternSize,

        previewImage, // ✅ correct per-item image
      })
    );
  }

  setOrders([]);
  navigate("/cart");
};


const PatternBox = ({ url, x, y, size }) => (
  <div
    style={{
      position: "absolute",
      left: x,
      top: y,
      width: size,
      height: size,
    }}
  >
    <img
      src={url}
      className="w-full h-full object-contain"
      draggable={false}
    />
  </div>
);


  return (
    <div className="p-4 max-w-6xl mx-auto">
      
     
{/* Themes */}
{/* Themes */}
<div className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-10 gap-4 mb-6">
  {themes.map((theme) => (
    <div key={theme.name} className="flex flex-col items-center">
      <button
        onClick={() => setSelectedTheme(theme.name)}
        className={`w-16 sm:w-full aspect-square rounded-full overflow-hidden border flex items-center justify-center ${
          selectedTheme === theme.name ? "ring-2 ring-violet-500" : ""
        }`}
      >
        <img
          src={theme.icon}
          className="w-full h-full object-cover"
          alt={theme.name}
        />
      </button>
      <span className="text-xs mt-1 text-center">{theme.name}</span>
    </div>
  ))}
</div>




      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Main Canvas */}
        <div className="lg:col-span-2 flex justify-center">
         <div
  id="tshirt-canvas"
  className="relative w-[380px] h-[460px] bg-white rounded shadow overflow-hidden"
>

<img src={tshirtImages[selectedColor]} className="w-full h-full object-contain" />

            {activeTab === "editor" &&
              placedPatterns.map((p) => (
                <Rnd
                  key={p.id}
                  default={{ x: p.x, y: p.y, width: p.size, height: p.size }}
                  bounds="parent"
                  onDragStop={(e, d) => {
                    setPlacedPatterns((prev) =>
                      prev.map((i) => (i.id === p.id ? { ...i, x: d.x, y: d.y } : i))
                    );
                  }}
                  onResizeStop={(e, dir, ref) => {
                    const newSize = parseInt(ref.style.width);
                    setPlacedPatterns((prev) =>
                      prev.map((i) => (i.id === p.id ? { ...i, size: newSize } : i))
                    );
                  }}
                >
                  <div className="relative">
                    <img src={p.url} className="w-full h-full" />
                    <button
                      onClick={removePattern}
                      className="absolute top-0 right-0 bg-red-500 text-white text-xs px-1 rounded"
                    >
                      X
                    </button>
                  </div>
                </Rnd>
              ))}

          
          </div>
        </div>

        {/* Controls */}
        <div className="bg-white p-4 rounded shadow">
          {/* Tabs */}
          <div className="flex gap-3 mb-4">
            <button
              onClick={() => setActiveTab("editor")}
              className={`px-4 py-2 rounded ${
                activeTab === "editor" ? "bg-black text-white" : "bg-gray-200"
              }`}
            >
              Editor
            </button>

            {/* POPUP BUTTON (New) */}
            <button
              onClick={() => setShowPopup(true)}
              className="px-4 py-2 rounded bg-gray-200"
            >
              Preview
            </button>
          </div>

         

          {/* Color */}
          <div className="mb-4">
            <label className="block mb-1 text-sm">Color</label>
            <div className="flex gap-3">
              {["white", "black", "navy", "brown", "cream", "skyblue"].map((c) => (
  <button
    key={c}
    onClick={() => setSelectedColor(c)}
    className={`w-10 h-10 rounded-full border ${
      selectedColor === c ? "ring-2 ring-black" : ""
    }`}
    style={{
      background:
        c === "white"
          ? "#ffffff"
          : c === "black"
          ? "#000000"
          : c === "navy"
          ? "#001f3f"
          : c === "brown"
          ? "#5c4033"
          : c === "cream"
          ? "#f5f5dc"
          : "#87ceeb", // light sky blue
    }}
  />
))}

            </div>
          </div>

          {/* Size */}
          <div className="mb-4">
            <label className="block mb-1 text-sm">Size</label>
            <select
              value={size}
              onChange={(e) => setSize(e.target.value)}
              className="w-full border rounded p-2"
            >
              <option>S</option>
              <option>M</option>
              <option>L</option>
              <option>XL</option>
              <option>XXL</option>
            </select>
          </div>

          {/* Qty */}
          <div className="flex gap-2 items-center mb-4">
            <button onClick={() => setQty((q) => Math.max(1, q - 1))} className="px-3 py-1 bg-gray-200 rounded">
              -
            </button>
            <div className="px-4 py-1 border rounded">{qty}</div>
            <button onClick={() => setQty((q) => q + 1)} className="px-3 py-1 bg-gray-200 rounded">
              +
            </button>
          </div>

          <div className="text-lg font-bold mb-4">Total: ₹{price * qty}</div>

          {errorText && <div className="text-sm text-red-600 mb-3">{errorText}</div>}

          <button onClick={addOrderLine} className="w-full py-3 bg-black text-white rounded">
            Add to List
          </button>

          <div className="mt-6">
            <h4 className="font-semibold mb-3">Your Selected Items</h4>

            {orders.length === 0 && <div className="text-sm text-gray-500">No items yet.</div>}

            {orders.map((o) => {
              const scale = THUMB_W / CANVAS_W;
              return (
                <div key={o.id} className="flex justify-between p-2 border rounded mb-2">
                  <div className="flex gap-3">
                    <div className="relative w-[72px] h-[92px] border rounded overflow-hidden">
                      <img src={o.tshirt} className="w-full h-full object-contain" />
                      <img
                        src={o.pattern}
                        style={{
                          position: "absolute",
                          left: Math.round(o.patternX * scale),
                          top: Math.round(o.patternY * scale),
                          width: Math.round(o.patternSize * scale),
                          height: Math.round(o.patternSize * scale),
                        }}
                      />
                    </div>

                    <div>
                      <div className="font-semibold capitalize">
                        {o.color} <span className="text-xs text-gray-500">({o.sizeLabel})</span>
                      </div>

                      <div className="flex gap-2 mt-2 text-sm">
                        <button
                          onClick={() => decreaseOrderQty(o.id)}
                          className="px-2 py-1 bg-gray-100 rounded"
                        >
                          -
                        </button>
                        <span>{o.qty}</span>
                        <button
                          onClick={() => increaseOrderQty(o.id)}
                          className="px-2 py-1 bg-gray-100 rounded"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-4">
                    <div className="font-semibold">₹{o.total}</div>
                    <button onClick={() => deleteOrderLine(o.id)} className="text-red-500 text-xl">
                      ✕
                    </button>
                  </div>
                </div>
              );
            })}

            {orders.length > 0 && (
              <>
                <div className="mt-3 flex justify-between border-t pt-3">
                  <span>Subtotal</span>
                  <strong>₹{subtotal}</strong>
                </div>

                <button
  disabled
  className="w-full mt-4 py-3 bg-gray-400 text-white rounded cursor-not-allowed"
>
  Launching Soon...
</button>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Pattern List */}
      <div className="mt-6 bg-white p-4 rounded shadow">
        <h4 className="font-semibold mb-3">{selectedTheme} — Patterns (Click to add)</h4>

        <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
          {patternList.map((p, i) => (
            <button key={i} onClick={() => addPattern(p)} className="border rounded overflow-hidden">
              <img src={p}  className="w-full h-28 sm:h-32 md:h-40 object-contain bg-white"/>
            </button>
          ))}
        </div>
      </div>

      {/* ===================== POPUP FULL PREVIEW ===================== */}
      {false && (
        <div
          className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
          onClick={() => setShowPopup(false)}
        >
          <div
            className="relative bg-white p-4 rounded shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowPopup(false)}
              className="absolute top-2 right-2 text-black text-xl"
            >
              ✕
            </button>

           {/* FULLSCREEN PREVIEW */}
<div
  className="relative"
  style={{
    width: POPUP_W,
    height: Math.round(CANVAS_H * POPUP_SCALE),
  }}
>
  <img
    src={tshirtImages[selectedColor]}
    className="w-full h-full object-contain"
  />

  {placedPatterns.map((p) => (
    <PatternBox
      key={p.id}
      url={p.url}
      x={p.x * POPUP_SCALE}
      y={p.y * POPUP_SCALE}
      size={p.size * POPUP_SCALE}
    />
  ))}
</div>

          </div>
        </div>
      )}
      {/* =============================================================== */}
    </div>
  );
}
